module.exports = __webpack_public_path__ + "static/media/pfizer-ireland-pharmaceuticals.2361b10c.jpg";